import React from 'react'
import {
  DiscountedCashFlowResponseData,
  FinancialsGrowthResponseData,
} from '../Config/types'
import Spinner from './Spinner'
import ValuationBarChart from './ValuationBarChart'
import GrowthLineChart from './GrowthLineChart'
import PlaceholderText from './PlaceholderText'
import { ContentSection } from './Layout'

interface OverviewContentProps {
  discountedCashFlowResponseData: DiscountedCashFlowResponseData | null
  financialsGrowthResponseData: FinancialsGrowthResponseData | null
  loading: boolean
  maximalGrowthRate?: number
}

export const OverviewContent: React.FC<OverviewContentProps> = ({
  discountedCashFlowResponseData,
  financialsGrowthResponseData,
  loading,
  maximalGrowthRate,
}) => {
  return (
    <>
      {discountedCashFlowResponseData && (
        <ContentSection sx={{ mb: 2.5 }}>
          <ValuationBarChart 
            responseData={discountedCashFlowResponseData}
            maximalGrowthRate={maximalGrowthRate}
          />
        </ContentSection>
      )}
      {!discountedCashFlowResponseData && loading && <Spinner />}
      {!financialsGrowthResponseData && loading && <Spinner />}
      {financialsGrowthResponseData && (
        <ContentSection sx={{ mt: 2.5 }}>
          <GrowthLineChart 
            data={financialsGrowthResponseData}
            dataField="mean_growth_rate"
            invertXAxisSort={true}
          />
        </ContentSection>
      )}
      {!discountedCashFlowResponseData && !financialsGrowthResponseData && !loading && (
        <PlaceholderText />
      )}
    </>
  )
}

export default OverviewContent
